import { render, staticRenderFns } from "./KitRouterDetails.vue?vue&type=template&id=b23e3b3a"
import script from "./KitRouterDetails.vue?vue&type=script&lang=ts"
export * from "./KitRouterDetails.vue?vue&type=script&lang=ts"
import style0 from "./KitRouterDetails.vue?vue&type=style&index=0&id=b23e3b3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports